module.exports = {
    header: {
        dates: {
            date: 'СЕНТЯБРЯ 2018',
            place: 'МОСКВА ВНУКОВО-3',
        },
        slogan: `
      Не пропустите<br/>
      совершенно новое<br/>
      событие в мире<br/>
      бизнес-авиации <span>rubae</span>
      `,
        button: 'Станьте участником',
        registrationButton: 'Купить билет',
    },
    about: {
        visitors: 'Более 8000 посетителей',
        aircrafts: 'Более 30 самолетов и вертолетов',
        conference: 'Новая программа конференций',
        about: 'Узнать больше о выставке',
    },
    exhibitors: {
        exhibitors: {
            title: 'Участники',
            buttonTitle: 'Станьте участником',
            text: 'Открыт прием заявок на участие в RUBAE2018.',
            links: {
                'exhibitor-manual': 'Руководство участника',
                'pages/general-contractor': 'Генеральный застройщик',
                'pages/freight-forwarder': 'Официальный экспедитор',
                'pages/catering-partner': 'Официальный кейтеринг-партнер',
                'pages/visa-support': 'Визовая поддержка',
            },
            personalAccountButton: 'Вход в личный кабинет',
        },
        attendee: {
            title: 'Посетители',
            buttonTitle: 'Купить билет',
            text:
                'Центр бизнес-авиации Внуково-3 приглашает посетить единственное событие в отрасли деловой авиации в России и странах СНГ в период с 12 по 14 сентября 2018 года.',
            links: {
                'pages/about': 'Основная информация',
                'pages/location': 'Местоположение',
                'pages/exhibitor-list': 'Список участников',
                pavilion_exposition: 'Схема выставочной экспозиции',
            },
        },
    },
    sponsors: 'Партнеры',
    'info-sponsors': 'Информационная поддержка',
    contacts: {
        title: 'Свяжитесь с нами',
        legalInfo: 'Правовая информация',
        confidention: 'Соглашение о конфиденциальности',
    },
    contactForm: {
        name: 'Название компании',
        contactPerson: 'Контактное лицо',
        tel: 'Телефон',
        email: 'E-mail',
        address: 'Адрес',
        website: 'Веб-сайт',
        stand: 'Стенд',
        static: 'Статика',
        submit: 'Отправить',
        formatLabel: 'Формат участия',
        successMessage: 'Спасибо! Мы обязательно свяжемся с Вами.',
        errorMessage: 'Что-то пошло не так, попробуйте позже.',
    },
    exhibitApplication: {
        applicationTypeButton: 'Выберите тип размещения',
        valuePlaceholder: 'Введите значение',
        services: {
            shellScheme: {
                title: 'Оборудованная площадь (мин. 6㎡)',
                description:
                    'ОБОРУДОВАННАЯ ПЛОЩАДЬ включает: выставочную площадь, стеновые панели, ковровое покрытие, 1 электрическую розетку, 1 стол, 2 стула, 1 лампа, фризовую панель, страхование ответственности, информацию о компании в официальном каталоге RUBAE. Строительство стенда осуществляется Генеральным застройщиком RUBAE.',
            },
            spaceOnly: {
                title: 'Необорудованная площадь (мин. 18㎡)',
                description:
                    'НЕОБОРУДОВАННАЯ ПЛОЩАДЬ включает:страхование ответственности, информацию о компании в официальном каталоге RUBAE. Строительство и оформление стенда осуществляется согласно требованиям руководства участника.',
            },
            staticDisplayChalet3: {
                title: 'Шале на статической площадке (3×3)',
                description:
                    'ШАЛЕ включает:название компании над входом, 1 розетку, ковровое покрытие.',
            },
            staticDisplayChalet5: {
                title: 'Шале на статической площадке (5×5)',
                description:
                    'ШАЛЕ включает:название компании над входом, 1 розетку, ковровое покрытие.',
            },
            upperDeck: {
                title: 'Второй этаж (double storey - space only)',
            },
            wallBrandingChalet3: {
                title: 'Брендирование стены (для шале 3×3)',
            },
            wallBrandingChalet5: {
                title: 'Брендирование стены (для шале 5×5)',
            },
            catalogueAdPage05: { title: '1/2 полоса, полноцвет.' },
            catalogueAdPage1: { title: '1/1 полоса, полноцвет.' },
        },
        units: {
            sqrm: '㎡',
            unit: 'шт.',
        },
        addButton: 'Добавить размещение',
        catalogueAd: 'Реклама в официальном каталоге',
        total: 'Итого',
        formTitle: 'Заявка на участие',
        contactsTitle: 'Контакты',
        contactsSubtitle: '(все поля обязательны)',
        allocationTitle: 'Размещение',
        comment:
            'Данная заявка является основанием для заключения договора и выставления счета, который должен быть оплачен в размере 50% в течении 10 дней после его выставления. Расчет 50% до 31 июля 2018 года. Цены указаны с НДС 18%. Обращаем Ваше внимание на то, что предоплата 50% не возвращается в случае отказа компании от участия в выставке.',
    },
    pages: {
        schedule: {
            about: 'Общая информация',
            registration: 'Регистрация',
            preview: 'Анонс',
            schedule: 'Программа',
            scheduleLink: 'Скачать программу конференций выставки RUBAE',
        },
    },
};



// WEBPACK FOOTER //
// ./src/data/messages/ru.js